import React from "react";
import AlertMessage from "../../../partials/alertMessage";
import SiteProfile from "../Site/partials/siteProfile";
import { NavLink } from "react-router-dom";
import { useMutation } from "@apollo/react-hooks";
import { CHANGE_SITE } from "../../../queries/staff.query";
import LoadingSpinner from "../../../partials/loading";
import AuthProvider from "../../../providers/Auth.Provider";

const SiteList = ({ sites, onUpdate }) => {
	const {
		LogOut,
		GetToken,
		GetAuthenticatedStaff
	} = AuthProvider.authProvider;
	const { site } = GetToken() && GetAuthenticatedStaff();

	const [postChange, { loading, error }] = useMutation(CHANGE_SITE, {
		onCompleted: data => {
			alert(data.ChangeStaffSite.message);
			LogOut();
			document.location.reload(true);
		}
	});
	return (
		<>
			{error && <AlertMessage message={error.message} failed={true} />}
			<LoadingSpinner loading={loading} />
			{sites && sites.length > 0 ? (
				<div className="table-scrollable">
					<table className="table table-hover full-width table-bordered">
						<thead>
							<tr className="text-left">
								<th className="text-center">SN</th>
								<th className="m-l-10"> Site </th>
								<th>Tel-Number</th>
								<th>Created</th>
								<th className="text-center">Actions</th>
							</tr>
						</thead>
						<tbody>
							{sites.map((s, index) => (
								<tr
									key={index}
									className="odd gradeX text-left"
								>
									<td className="text-center">
										<strong>{index + 1}</strong>
									</td>

									<td className="table-patient-display">
										<SiteProfile site={s} />
									</td>

									<td>
										{s.tel}
										{site.id === s.id && (
											<p>
												<span className="badge badge-success">
													Active Site
												</span>
											</p>
										)}
									</td>
									<td>
										{new Date(
											parseInt(s.created_at)
										).toLocaleDateString()}
									</td>
									<td className="text-center">
										{site.id !== s.id && (
											<button
												title="Make Primary Site"
												className="btn btn-tbl-edit btn-xs text-success fade-in"
												onClick={async () => {
													if (
														window.confirm(
															"Are you sure you want to make this site your primary site?"
														)
													) {
														await postChange({
															variables: {
																site: s.id
															}
														});
													}
												}}
											>
												<i className="fa fa-user-md"></i>
											</button>
										)}
										<button
											title="Update"
											className="btn btn-tbl-edit btn-xs text-primary"
											onClick={() => onUpdate(s)}
										>
											<i className="fa fa-pencil"></i>
										</button>
										<NavLink
											to={{
												pathname: `/home/app-management/site-detail/${s.id}`
											}}
											title="View"
											className="btn btn-tbl-edit btn-xs text-blue"
										>
											<i className="fa fa-eye"></i>
										</NavLink>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			) : (
				<AlertMessage message="No Site is created yet." failed={true} />
			)}
		</>
	);
};
export default SiteList;
